var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { rssListFR, rssListPT, rssListPL, rssListEN, rssListES, rssListDE, referenceTrad } from '../../datas/rssList_lang';
import '../../styles/PopUp.css';
import { useLanguage } from '../context/LanguageContext';
import { useAppState } from '../context/AppStateContext';
import MultiPopUp from './MultiPopUp';
export default function PopUp(props) {
    var language = useLanguage().language;
    var _a = useAppState(), productName = _a.productName, resetProductName = _a.resetProductName, setProductNameMulti = _a.setProductNameMulti, setIsPopupOpen = _a.setIsPopupOpen;
    var _b = useState([]), title = _b[0], setTitle = _b[1];
    var _c = useState(""), subtitle = _c[0], setSubtitle = _c[1];
    var _d = useState(""), reference = _d[0], setReference = _d[1];
    var imgPath = "./Ressources/" + productName + "/visuel_" + productName + ".png";
    var _e = useState(""), logoPath = _e[0], setLogoPath = _e[1];
    var _f = useState(""), altSubsidiaryLogo = _f[0], setAltSubsidiaryLogo = _f[1];
    var _g = useState(""), hrefSubsidiaryLogo = _g[0], setHrefSubsidiaryLogo = _g[1];
    var _h = useState([]), certifs = _h[0], setCertifs = _h[1];
    var _j = useState(""), description = _j[0], setDescription = _j[1];
    var _k = useState(""), videoLink = _k[0], setVideoLink = _k[1];
    var _l = useState(""), productLink = _l[0], setProductLink = _l[1];
    var _m = useState(""), technicalLink = _m[0], setTechnicalLink = _m[1];
    var _o = useState(""), videoPageLink = _o[0], setVideoPageLink = _o[1];
    var _p = useState(""), constructLink = _p[0], setConstructLink = _p[1];
    var _q = useState(false), isShown = _q[0], setIsShown = _q[1];
    var firstPass = useRef(false);
    var closePopUp = function (event) {
        setIsShown(false);
        resetProductName();
        setProductNameMulti("");
        setIsPopupOpen(false);
        props.unlockPlayer();
        if (isMobile)
            props.uncrouchPlayer();
    };
    var showPopUp = function () {
        setIsShown(true);
        setIsPopupOpen(true);
        props.lockPlayer();
    };
    function getProductInfo() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var data, subsidiary, path, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, import("../../Ressources/".concat(productName, "/").concat(props.subsidiaryForTexts, "_textes_liens_").concat(productName, "_").concat(language, ".json"))];
                    case 1:
                        data = _g.sent();
                        setTitle(data.texts.title || []);
                        setSubtitle(data.texts.subtitle || "");
                        setReference(data.texts.reference || "");
                        setDescription(data.texts.description || "");
                        setVideoLink(((_a = data.links) === null || _a === void 0 ? void 0 : _a.video) || "");
                        setCertifs(((_b = data.links) === null || _b === void 0 ? void 0 : _b.normes) || []);
                        subsidiary = data.links.logo;
                        path = subsidiary.substring(0, subsidiary.length - 4) + ".svg";
                        setLogoPath("./imgs/logos-filiales/" + path);
                        switch (subsidiary) {
                            case "logo-sectoriel.svg":
                                setHrefSubsidiaryLogo("https://www.sectoriel.com/fr/");
                                setAltSubsidiaryLogo("Logo Sectoriel");
                                break;
                            case "logo-sferaco.svg":
                                setHrefSubsidiaryLogo("https://www.sferaco.com/fr/");
                                setAltSubsidiaryLogo("Logo Sferaco");
                                break;
                            case "logo-sferaco-sectoriel.svg":
                                setHrefSubsidiaryLogo("");
                                setAltSubsidiaryLogo("Logos Sferaco et Sectoriel");
                                break;
                            default:
                                break;
                        }
                        setProductLink(((_c = data.links) === null || _c === void 0 ? void 0 : _c.productLink) || "");
                        setTechnicalLink(((_d = data.links) === null || _d === void 0 ? void 0 : _d.technicalFile) || "");
                        setVideoPageLink(((_e = data.links) === null || _e === void 0 ? void 0 : _e.pageVideo) || "");
                        setConstructLink(((_f = data.links) === null || _f === void 0 ? void 0 : _f.constructFile) || "");
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        console.error("Erreur lors du chargement des textes du produit :", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        if (firstPass.current && productName !== "") {
            getProductInfo();
            if (productName)
                showPopUp();
        }
        firstPass.current = true;
    }, [productName]);
    useEffect(function () {
        var scrollContainer = document.querySelector(".main_popup_left");
        if (isShown && scrollContainer) {
            scrollContainer.scrollTop = 0;
        }
    }, [productName, isShown]);
    useEffect(function () {
        if (productName)
            getProductInfo();
    }, [language]);
    // Masque le bouton de menu et évite tout recouvrement
    useEffect(function () {
        if (isShown) {
            document.body.classList.add("popup-open");
        }
        else {
            document.body.classList.remove("popup-open");
        }
        return function () { return document.body.classList.remove("popup-open"); };
    }, [isShown]);
    // ESC pour fermer
    useEffect(function () {
        if (!isShown)
            return;
        var handleKeyDown = function (event) {
            if (event.key === 'Escape' || event.key === 'Esc') {
                event.preventDefault();
                closePopUp(event);
            }
        };
        window.addEventListener('keydown', handleKeyDown, { capture: true });
        return function () {
            window.removeEventListener('keydown', handleKeyDown, { capture: true });
        };
    }, [isShown]);
    return (_jsxs("div", __assign({ className: "popup", style: { display: isShown ? 'block' : 'none' }, role: "dialog", "aria-modal": "true" }, { children: [_jsx("div", { className: "popup_underlay", onClick: function (e) { console.log("on click underlay"); closePopUp(e); }, onKeyDown: function (e) { if (e.key === 'Escape')
                    closePopUp(e); }, role: "button", tabIndex: 0, "aria-label": "Fermer" }), _jsxs("div", __assign({ className: "main_popup" }, { children: [_jsxs("div", __assign({ className: "main_popup_left" }, { children: [_jsx("div", __assign({ className: "popup_header_sticky" }, { children: _jsx(CloseIcon, { closeFunction: closePopUp }) })), _jsxs("div", __assign({ className: "popup_content" }, { children: [_jsx(PopUpHeader, { certifs: certifs, subsidiaryLogoPath: logoPath, imgPath: imgPath, altSubsidiaryLogo: altSubsidiaryLogo, hrefSubsidiaryLogo: hrefSubsidiaryLogo }), _jsx(ProductTitle, { title: title, subtitle: subtitle }), _jsx(ResourcesList, { ProductLink: productLink, TechnicalLink: technicalLink, ConstructLink: constructLink, VideoLink: videoLink, VideoPageLink: videoPageLink }), reference && reference !== "" && (_jsx(ProductReference, { reference: reference })), _jsx(ProductDescription, { content: description }), _jsx(VideoIframe, { link: videoLink })] }))] })), _jsx(MultiPopUp, { outlineObj: props.outlineObj, subsidiaryForTexts: props.subsidiaryForTexts })] }))] })));
}
function CloseIcon(props) {
    return (_jsx("div", __assign({ className: "close_popup", onClick: props.closeFunction, onKeyDown: props.closeFunction, onTouchStart: props.closeFunction, role: "button", tabIndex: 0, "aria-label": "Fermer" }, { children: _jsx(FontAwesomeIcon, { icon: faCircleXmark, size: "2xl", style: { color: "#61c3ef" } }) })));
}
function PopUpHeader(props) {
    return (_jsx("div", __assign({ className: "popup_header" }, { children: _jsxs("div", __assign({ className: "product-container" }, { children: [_jsx(SubsidiaryLogo, { subsidiaryLogoPath: props.subsidiaryLogoPath, altSubsidiaryLogo: props.altSubsidiaryLogo, hrefSubsidiaryLogo: props.hrefSubsidiaryLogo }), _jsx(ProductImg, { imgPath: props.imgPath }), _jsx(CertificationsList, { certifs: props.certifs })] })) })));
}
function ProductImg(props) {
    return (_jsx("div", __assign({ className: "popup-image-container" }, { children: _jsx("img", { id: "imgPopUp", src: props.imgPath, alt: "Produit" }) })));
}
function SubsidiaryLogo(props) {
    return (_jsx("div", __assign({ id: "logo_filiale" }, { children: _jsx("a", __assign({ id: "filiale_link", href: props.hrefSubsidiaryLogo, target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { id: "popup_logo_filiale", src: props.subsidiaryLogoPath, alt: props.altSubsidiaryLogo }) })) })));
}
function CertificationsList(props) {
    var listItems = props.certifs.map(function (certif, index) { return (_jsx(OverlayTrigger, __assign({ placement: "top", overlay: _jsx(Tooltip, __assign({ id: "tooltip-".concat(index), style: { zIndex: 35 } }, { children: certif.description })) }, { children: _jsx("img", { src: "./Ressources/certifications/".concat(certif.url), alt: certif.description, className: "certification-icon" }) }), index)); });
    return _jsx("div", __assign({ className: "certifications-container" }, { children: listItems }));
}
function ProductTitle(props) {
    var title = "";
    for (var i = 0; i < props.title.length; i++)
        title += props.title[i] + "\n";
    return (_jsxs("div", __assign({ className: "popup_block", id: "popup_titles" }, { children: [_jsx("h2", __assign({ id: "popUpTitre" }, { children: title })), _jsx("br", {}), _jsx("i", __assign({ id: "popUpSousTitre" }, { children: props.subtitle }))] })));
}
function ProductReference(props) {
    var language = useLanguage().language;
    return (_jsx("div", __assign({ className: "popup_block" }, { children: _jsxs("b", __assign({ id: "popUpReference" }, { children: [referenceTrad[language] || referenceTrad['fr'], " : ", props.reference] })) })));
}
function ResourcesList(props) {
    var language = useLanguage().language;
    var emptyList = useRef(true);
    var listItems;
    updateTexts();
    function updateTexts() {
        var obj = [];
        switch (language) {
            case "fr":
                obj = rssListFR;
                break;
            case "en":
                obj = rssListEN;
                break;
            case "es":
                obj = rssListES;
                break;
            case "pl":
                obj = rssListPL;
                break;
            case "pt":
                obj = rssListPT;
                break;
            case "de":
                obj = rssListDE;
                break;
            default:
                obj = rssListFR;
                break;
        }
        listItems = obj.map(function (rss, index) {
            if (index === 0 && props.ProductLink !== "") {
                emptyList.current = false;
                return _jsx(Resource, { Title: rss.title, AId: rss.aId, ImgClass: rss.imgClass, LiId: rss.liId, Tooltip: (rss.tooltip !== undefined) ? rss.tooltip : "", PathNormal: rss.pathNormal, PathHover: rss.pathHover, RssLink: props.ProductLink }, rss.aId);
            }
            else if (index === 1 && props.TechnicalLink !== "") {
                emptyList.current = false;
                return _jsx(Resource, { Title: rss.title, AId: rss.aId, ImgClass: rss.imgClass, LiId: rss.liId, Tooltip: (rss.tooltip !== undefined) ? rss.tooltip : "", PathNormal: rss.pathNormal, PathHover: rss.pathHover, RssLink: props.TechnicalLink }, rss.aId);
            }
            else if (index === 2 && props.ConstructLink !== "") {
                emptyList.current = false;
                return _jsx(Resource, { Title: rss.title, AId: rss.aId, ImgClass: rss.imgClass, LiId: rss.liId, Tooltip: (rss.tooltip !== undefined) ? rss.tooltip : "", PathNormal: rss.pathNormal, PathHover: rss.pathHover, RssLink: props.ConstructLink }, rss.aId);
            }
            else if (index === 3 && props.VideoPageLink !== "") {
                emptyList.current = false;
                return _jsx(Resource, { Title: rss.title, AId: rss.aId, ImgClass: rss.imgClass, LiId: rss.liId, Tooltip: (rss.tooltip !== undefined) ? rss.tooltip : "", PathNormal: rss.pathNormal, PathHover: rss.pathHover, RssLink: props.VideoPageLink }, rss.aId);
            }
            return null;
        });
    }
    if (listItems !== undefined && listItems[0] !== undefined)
        return (_jsx("div", __assign({ className: "popup_block", id: "popup_links" }, { children: _jsx("ul", __assign({ className: "liste_ressources", id: "liste_rss" }, { children: listItems })) })));
    else
        return _jsx("br", {});
}
function Resource(props) {
    var _a = useState(props.PathNormal), srcImg = _a[0], setSrcImg = _a[1];
    var _b = useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var changeIcon = function () {
        if (isHovered)
            setSrcImg(props.PathNormal);
        else
            setSrcImg(props.PathHover);
        setIsHovered(!isHovered);
    };
    return (_jsx("li", __assign({ id: props.LiId, className: "resource-item" }, { children: _jsxs("a", __assign({ id: props.AId, href: props.RssLink, target: "_blank", rel: "noreferrer", onMouseEnter: changeIcon, onMouseLeave: changeIcon, className: "resource-link" }, { children: [_jsx("img", { className: "popup-link " + props.ImgClass, alt: props.Title, src: srcImg }), _jsx("span", __assign({ className: "resource-text" }, { children: props.Tooltip }))] })) })));
}
function ProductDescription(props) {
    return (_jsx("div", __assign({ className: "popup_block", id: "popup_desc" }, { children: _jsx("p", __assign({ id: "description" }, { children: props.content })) })));
}
function VideoIframe(props) {
    var element = (props.link !== "") ? (_jsx("div", __assign({ className: "popup_block", id: "popup_video" }, { children: _jsx("iframe", { className: 'popup_video_frame', src: props.link, title: 'Video', frameBorder: '0', allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture', allowFullScreen: true }) }))) : null;
    return _jsx(_Fragment, { children: element });
}
